import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    data: {name: 'Ricerca Crociere', canNavigate: false},
    path: 'ricerca',
    loadChildren: () => import('./cruise-search-page/cruise-search-page.module').then(m => m.CruiseSearchPageModule)
  },
  {
    data: {name: 'Dettaglio Crociera', canNavigate: false},
    path: 'dettaglio',
    loadChildren: () => import('./cruise-detail-page/cruise-detail-page.module').then(m => m.CruiseDetailPageModule)
  },
  {
    data: {name: 'Booking Crociere', canNavigate: false},
    path: 'booking',
    loadChildren: () => import('./cruise-booking-page/cruise-booking-page.module').then(m => m.CruiseBookingPageModule)
  }
]

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class CruiseModule { }
